import type { TRouteParams } from '../definitions'

import { Number } from 'stdlib/Number'
import { URI }    from 'stdlib/URI'
import { is }     from 'stdlib/is'

import getPartsFromPath from './getPartsFromPath'

/**
 * A paraméterek az url és a route alapján.
 * @param url   - Az url.
 * @param route - A route, amiben vannak definiálva a paraméterek helyei.
 */
export default function getParamsByUrlAndRoute (url: string, route: string): TRouteParams {
  /** Ez a valid url. */
  const urlParts = getPartsFromPath(url)

  /** Ez a router-ben definiált route. */
  const routeParts = getPartsFromPath(route)

  const params: TRouteParams = {}

  // TODO: reduce
  routeParts.forEach((route, index) => {
    const value = urlParts[index]
    const [ , paramName ] = route.split(':')

    if (is.string(value) && is.string(paramName)) {
      params[paramName] = is.numeric(value)
        ? Number.parse(value)
        : URI.decodeComponent(value)
    }
  })

  return params
}
